module.exports = __webpack_public_path__ + "72c5e1ebf6dbcb482c292e21edca8d84.svg";